import {
  Box, Dialog, IconButton, Typography,
  Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import SketchDiagram from '../../../../Components/Common Components/SketchDiagram';
import { FundusImage } from '../../../../Utility/Constants';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const UmaFundus = (data) => {
  const [fundus, setFundus] = useState({
    openFundusPopup: false,
    patientId: '',
    clinicId: '',
    appointmentId: '',
    doctorId: '',
    fundusImage: FundusImage,
    prevFundusImage: FundusImage,
    dupFundusImage: JSON.stringify(FundusImage)
  })
  const [isCopyDisabled, setIsCopyDisabled] = useState(true);
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: message,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: message,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  const apicalls = async () => {
    await getFundusDiagram()
    await getPrevFundusImageData()
  }

  const getFundusDiagram = async () => {
    try {
      let response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_FUNDUS_DIAGRAM + `?appointment_id=${data?.props?.appointment_id}&doctor_id=${data?.props?.doctorID}`)
      if (response.data.status === 'success') {
        const data = response.data.data
        if (data?.fundus_image_key) {
          await getImageFromAws(data?.fundus_image_key)
        } else {
          if (FundusImage) {
            setFundus((prev) => ({ ...prev, fundusImage: FundusImage, dupFundusImage: JSON.stringify(FundusImage) }))
          }
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPrevFundusImageData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_FUNDUS_DIAGRAM_COPY +
        '?appointment_id=' + data?.props.appointment_id + '&patient_id=' + data?.props?.patient_id + '&doctor_id=' + data?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        const data = response.data.data
        if (data?.fundus_image_key) {
          await getPrevImageFromAws(data?.fundus_image_key, 'prev')
          setIsCopyDisabled(false);
        } else {
          if (FundusImage) {
            setFundus((prev) => ({ ...prev, prevFundusImage: FundusImage }))
          }
          setIsCopyDisabled(true);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getImageFromAws = async (doc_key, type) => {
    try {
      const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key))
      if (response?.data?.status === 'success') {
        let list = response.data
        // if (type === 'prev') {
        //   setFundus((prev) => ({ ...prev, prevFundusImage: list?.data }))
        // } else {
        setFundus((prev) => ({ ...prev, fundusImage: list?.data, dupFundusImage: JSON.stringify(list?.data) }))
        data?.setAccordionOpen(list?.data ? true : false)
        // }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPrevImageFromAws = async (doc_key, type) => {
    try {
      const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key))
      if (response?.data?.status === 'success') {
        let list = response.data
        setFundus((prev) => ({ ...prev, prevFundusImage: list?.data }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const dataURItoBlob = (dataURI) => {
    var byteString = atob(dataURI.split(",")[1]);
    var mimeString = dataURI
      .split(",")[0]
      .split(":")[1]
      .split(";")[0];

    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  };

  const postFundusDiagram = async (propsData) => {
    try {
      if (propsData) {
        let drawings = [];
        drawings.push(propsData);
        var lengths = (drawings.length) - 1
        let form = new FormData();
        form.append('appointment_id', data?.props?.appointment_id);
        form.append('fundus_image_key', dataURItoBlob(drawings[lengths]));
        form.append('image_json', (JSON.stringify(propsData)));

        let response = await RestAPIService.create(form, Serviceurls.NEW_DOC_NOTES_FUNDUS_DIAGRAM)
        if (response.data?.status === 'success') {
          successMessage(response.data.message)
          await getFundusDiagram()
          setFundus((prev) => ({ ...prev, openFundusPopup: false }))
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const deleteFundusDiagram = async (propsData) => {
    try {
      if (propsData) {
        let drawings = [];
        drawings.push(propsData);
        var lengths = (drawings.length) - 1
        let form = new FormData();
        form.append('appointment_id', data?.props?.appointment_id);
        form.append('fundus_image_key', dataURItoBlob(drawings[lengths]));
        form.append('image_json', (JSON.stringify(propsData)));

        let response = await RestAPIService.create(form, Serviceurls.NEW_DOC_NOTES_FUNDUS_DIAGRAM)
        if (response.data?.status === 'success') {
          successMessage(response.data.message)
          await getFundusDiagram()
          setFundus((prev) => ({ ...prev, openFundusPopup: false }))
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response.data.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const renderFundusPopup = () => {
    try {
      return (
        <Dialog open={fundus.openFundusPopup} maxWidth="md" fullWidth>
          <Box className='doc_diagram_popup'>
            <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Box component={'div'} display={'flex'} alignItems={'center'}>
                <Typography className='doc_notes_header_card_font'>Fundus</Typography>
                <IconButton emed_tid='fun_cpy'
                  onClick={() => setFundus((prev) => ({
                    ...prev,
                    fundusImage: fundus.prevFundusImage,
                  }))}
                  // disabled={JSON.stringify(fundus.prevFundusImage) === JSON.stringify(fundus.fundusImage)}
                  disabled={isCopyDisabled}
                >
                  {/* <ContentCopyIcon color={JSON.stringify(fundus.prevFundusImage) === JSON.stringify(fundus.fundusImage) ? '' : 'primary'} /></IconButton> */}
                  <ContentCopyIcon color={isCopyDisabled ? 'disabled' : 'primary'} /></IconButton>
              </Box>
              <IconButton emed_tid='fun_cls'
                onClick={() => setFundus({
                  ...fundus,
                  openFundusPopup: false,
                  fundusImage: JSON.parse(fundus.dupFundusImage)
                })}><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'}>
              <SketchDiagram
                onSave={postFundusDiagram}
                onDelete={deleteFundusDiagram}
                image={fundus.fundusImage}
                defaultImage={FundusImage}
              />
            </Box>
          </Box>
        </Dialog>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={data.accordionOpen}
          onChange={(_, isExpanded) => {
            data?.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
          <Box component={'div'} className='doc_notes_header_card'>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <Typography className='doc_notes_header_card_font'>Fundus</Typography>
              <Box component={'div'} display={'flex'}>
                {data?.props?.isOPT ?
                  <IconButton emed_tid='fun_open'
                    disabled={data?.props?.patient_transfered || data?.props?.isLocked}
                      onClick={(e) => {
                        e.stopPropagation();
                        setFundus({ ...fundus, openFundusPopup: true })
                      }}
                  ><AddCircleIcon color='primary' /></IconButton> : null}
              </Box>
            </Box>
          </Box>
          </AccordionSummary>
          <AccordionDetails>
          <Box component={'div'} display={'flex'} height={'45dvh'} justifyContent={'center'} alignItems={'center'}>
            <Box component={'img'} src={fundus?.fundusImage} alt='image' width={'100%'} />
          </Box>
          </AccordionDetails>
        </Accordion>
        {renderFundusPopup()}
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
}

export default UmaFundus